"use client";
import { useTranslations } from "next-intl";
import { Skeleton } from "@radix-ui/themes";
import { DataInputParams } from "./inputType";
import { Form, Switch, Skeleton as AntSkeleton, Tooltip, Button } from "antd";
import { Debug } from "@/util/debug";
import { checkDisabled, checkNoItem, GetDataInputElement } from "./inputFunction";
import SkeletonInput from "antd/es/skeleton/Input";
import { tooltipColor } from "../list/defaultType";
import { cn } from "@/lib/utils";
import Icon from "@/components/common/icon/icon";
import { useRef, useState } from "react";

export default function DataSwitch(params: DataInputParams) {
  const t = useTranslations(params.transitionGroup ?? "contents");
  const placeholder = params.placeholder ?? params.defaultValue ?? params.value;
  const prev = params.prev ? GetDataInputElement(params.prev, false, params.values, t) : undefined;
  const next = params.next ? GetDataInputElement(params.next, true, params.values, t) : undefined;
  const unitPrev = params.unitPrev ? GetDataInputElement(params.unitPrev, false, params.values, t) : undefined;
  const unit = params.unit ? GetDataInputElement(params.unit, true, params.values, t) : undefined;
  //Debug(params);
  //const disabled = params.inputMode == "read" ? true : params.disabled;
  const disabled = checkDisabled(params);
  const [checked, setChecked] = useState(params.value ?? params.defaultValue);

  const checkedProp = params.inputMode == "view" ? { checked: checked } : { checked: checked };

  const { checkedChildren, unCheckedChildren, buttonName, ...switchButtonProp } = params.switchButtonProp ?? {};

  const { iconName, iconType, ...children } = (checked ? checkedChildren : unCheckedChildren) ?? {};

  const title =
    switchButtonProp && switchButtonProp.title
      ? (switchButtonProp.titleTransition ?? true)
        ? t(switchButtonProp.title)
        : switchButtonProp.title
      : undefined;
  const ref = useRef<HTMLButtonElement | null>(null);
  const getInput = () => {
    return (
      <Switch
        ref={ref}
        {...params.switchProp}
        id={params.name}
        {...checkedProp}
        value={checked}
        // onChange={(e) => {
        //   Debug("onChange", e);
        //   if (params.onChange) {
        //     params.onChange(e);
        //   }
        // }}
        className="hidden"
      />
    );
  };
  return (
    <Tooltip color={tooltipColor} title={title}>
      {prev}
      {unitPrev}
      <Button
        className={cn(params.inputClassName, switchButtonProp?.buttonClassName)}
        {...switchButtonProp}
        {...children}
        name={params.name + "_swithbtn"}
        onClick={(e) => {
          Debug(ref.current);
          setChecked((prev: any) => {
            if (params.onChange) {
              params.onChange({ key: params.name, value: !prev, index: params.index, name: params.subListName });
            }
            return !prev;
          });
          if (switchButtonProp?.buttonClick) {
            switchButtonProp?.buttonClick(e);
          }
        }}
        icon={<Icon iconName={iconName ?? buttonName ?? "Coffee"} iconType="" weight="bold" className={""} />}
        disabled={disabled}
      >
        {title}
      </Button>
      {checkNoItem(params) ? (
        getInput()
      ) : (
        <Form.Item
          name={params.name}
          noStyle
          valuePropName="checked"
          initialValue={checked}
          required={params.required}
          onMetaChange={(e) => {
            Debug(e);
          }}
        >
          {getInput()}
        </Form.Item>
      )}
      {unit}
      {next}
    </Tooltip>
  );
}
